module.exports = __webpack_public_path__ + "img/interpackmaxi_dfod_dg_k.405e8f5b.png";